import type { ButtonProps } from '@chakra-ui/react';
import { Button, Box, HStack, Tooltip, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import useIsMobile from 'lib/hooks/useIsMobile';
import { useI18n } from 'lib/i18n/context';
import shortenString from 'lib/shortenString';
import IconSvg from 'ui/shared/IconSvg';

// import UserIdenticon from '../UserIdenticon';

interface Props {
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  onClick?: () => void;
  isPending?: boolean;
  isAutoConnectDisabled?: boolean;
  address?: string;
  domain?: string;
}

const UserWalletButton = ({ size, onClick, isPending, isAutoConnectDisabled, address, domain }: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {

  const isMobile = useIsMobile();
  const { t } = useI18n();

  const content = (() => {
    if (!address) {
      return (
        <Flex alignItems="center" gap={ 2 }>
          <Text fontSize="14px" fontWeight={ 600 } color="#000">{ t('user.connect') }</Text>
          <IconSvg name="arrows/arrow-right" width="16px" height="16px"/>
        </Flex>
      );
    }

    const text = domain || shortenString(address);

    return (
      <HStack gap={ 2 }>
        { /* <UserIdenticon address={ address } isAutoConnectDisabled={ isAutoConnectDisabled }/> */ }
        <Box>{ text }</Box>
        <Box display={{ base: 'none', md: 'block' }}>
          <IconSvg name="arrows/arrow-right" width="16px" height="16px"/>
        </Box>
      </HStack>
    );
  })();

  const addressOnMobile = Boolean(address && isMobile);
  let buttonPx: string | number = 4;
  if (addressOnMobile) buttonPx = '10px';
  else if (address) buttonPx = 2.5;

  let buttonFontWeight = 600;
  if (addressOnMobile) buttonFontWeight = 500;
  else if (address) buttonFontWeight = 700;

  return (
    <Tooltip
      label={ (
        <span style={{ color: 'white', whiteSpace: 'pre-line' }}>
          { t('user.connectWalletFullFeaturedTooltip') }
        </span>
      ) }
      textAlign="center"
      padding={ 2 }
      isDisabled={ isMobile || Boolean(address) || !address }
      openDelay={ 500 }
    >
      <Button
        ref={ ref }
        size={ size }
        // variant={ variant }
        onClick={ onClick }
        style={{ background: '#14DCAC', color: '#000' }}
        data-selected={ Boolean(address) }
        data-warning={ isAutoConnectDisabled }
        fontSize={ addressOnMobile ? '16px' : 'sm' }
        lineHeight={ 5 }
        h={ addressOnMobile ? '32px' : undefined }
        px={ buttonPx }
        fontWeight={ buttonFontWeight }
        borderRadius={ addressOnMobile ? '8px' : undefined }
        fontFamily={ addressOnMobile ? '\'Space Grotesk\', sans-serif' : undefined }
        isLoading={ isPending }
        loadingText={ isMobile ? undefined : t('user.connecting') }
      >
        { content }
      </Button>
    </Tooltip>
  );
};

export default React.memo(React.forwardRef(UserWalletButton));
